import { lazy, Suspense } from 'react';
const Loading = <div>Loading....</div>;
const CommnuityListPage = lazy(() => import('../pages/CommunityListPage'));
const CommnunitySettingPage = lazy(() => import('../pages/CommunitySettingPage'));

const communityAdminRouter = () => {
  return [
    {
      path: '',
      element: (
        <Suspense fallback={Loading}>
          <CommnuityListPage />
        </Suspense>
      ),
    },
    {
      path: ':id',
      element: (
        <Suspense fallback={Loading}>
          <CommnuityListPage />
        </Suspense>
      ),
    },
    {
      path: 'setting',
      element: (
        <Suspense fallback={Loading}>
          <CommnunitySettingPage />
        </Suspense>
      ),
    },
  ];
};

export default communityAdminRouter;
